import { icon, reactionTypes } from './icons.js';

export const ensureReactionOverlay = container => {
  const screen = container.firstElementChild;
  if (!screen) return null;
  if (getComputedStyle(screen).position === 'static') screen.style.position = 'relative';
  let overlay = screen.querySelector('.reaction-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'reaction-overlay';
    overlay.setAttribute('aria-live', 'polite');
    screen.appendChild(overlay);
  }
  return overlay;
};

export const showReaction = (container, reactionType) => {
  if (!reactionTypes.includes(reactionType)) return;
  const overlay = ensureReactionOverlay(container);
  if (!overlay) return;
  const reaction = document.createElement('div');
  reaction.className = `reaction-float reaction-${reactionType}`;
  reaction.style.left = `${Math.floor(Math.random() * 76) + 12}%`;
  reaction.style.setProperty('--reaction-drift', `${Math.floor(Math.random() * 120) - 60}px`);
  reaction.innerHTML = icon(reactionType, 'reaction-float-icon');
  overlay.appendChild(reaction);
  reaction.addEventListener('animationend', () => reaction.remove(), { once: true });
};
